import TagAnalysisChart from '@op/pages/community/video/components/TagAnalysisChart';
import { DetailConfigType } from '../types';

export const VideoTagAnalysis: DetailConfigType = {
  Component: TagAnalysisChart,
  defaultProps: {},
  title: 'Video Tag Analysis',
  detailPageOptions: {
    showViewMore: false,
    tableMode: 'video',
  },
};
